skrilla.directive('clientLedger', function () {
    return {
        templateUrl: 'directives/clientLedger/clientLedger.html',
        controller: function ($scope, searchService, csvService) {
            $scope.searchClientLedger = function () {
                csvService.openInV2CSVExporter('clientLedger', $scope.query)
            }

            $scope.query = {
                beforeDate: new Date()
            }

        }
    };
});
